<div class="container wrapper">
  <div class="columns" *ngIf="!mobile">
    <div class="column" *ngFor="let pack of packages">
      <app-package [package]="pack" (selectEvent)="selectPackage($event)" [hasAdditional]="infos" (infoRequest)="infoRequest.emit($event)"></app-package>
    </div>
  </div>

  <div class="container is-fluid" *ngIf="mobile">
    <div class="columns is-mobile">
      <div class="column is-fullwidth">
        <div class="box infoCard__mobile">
          <p style="text-align: center"> Immobilienkauf? Immobilienfinanzierung? Hausbau? <br>
            Jetzt Behördenauskünfte online anfordern!
          </p>
        </div>
        <div class="message is-info" style="padding: 1rem">
          <p style="text-align: center"> Auskünfte individuell zusammen stellen oder von den vergünstigten
            Aktionspaketen profitieren</p>
        </div>
      </div>
    </div>
    <div class="columns is-mobile" style="flex-wrap: wrap">

      <div class="column is-half" *ngFor="let pack of packages">
        <app-package-mobile [package]="pack" (selectEvent)="selectPackage($event)"
                            [hasAdditional]="infos"></app-package-mobile>
      </div>
    </div>
  </div>


</div>
